<div class="c-dailyChallenge">
  <div class="flying-assets-layer">
    <slotcom-flying-assets
      #flyingAssets
      [originElement]="animationOrigin$ | async"
      [config]="activeFlyingAssetsConfig">
    </slotcom-flying-assets>
  </div>
  <div class="c-dailyChallenge__main">
    <slotcom-progress-line-header [animate]="true"></slotcom-progress-line-header>

    <slotcom-wallet
      class="gems-wallet"
      [type]="'Gems'">
    </slotcom-wallet>

    <slotcom-wallet
      class="credits-wallet"
      [type]="'Coins'"
      [animate]="true">
    </slotcom-wallet>

    <slotcom-navigation-button
      type="close"
      [rightPosition]="3"
      (click)="closeModal()"></slotcom-navigation-button>

    <slotcom-navigation-button
      type="info"
      [leftPosition]="3"
      (click)="openInfo()"></slotcom-navigation-button>

    <div class="c-dailyChallenge__container">
      <div
        class="c-dailyChallenge__container__top"
        theming
        themingGroup="dailychallenge"
        themingAsset="top-background"
        [themingOverride]="dailyChallenge?.assets">
        <div class="c-dailyChallenge__container__logo">
          <div
            class="e-logo"
            data-testid="slotcom-dailyChallenge-modal-logo"
            theming
            themingGroup="dailychallenge"
            themingAsset="logo"
            [themingOverride]="dailyChallenge?.assets"></div>

          @if (showDailyChallenge()) {
            <div class="e-timer">
              <span class="text">{{ 'home.challenges.remaining' | translate }}:</span>

              <slotcom-animated-timer
                [showInDays]="true"
                [endDate]="dailyChallenge.endDate"
                (expired)="dailyChallengeExpired()"></slotcom-animated-timer>
            </div>
          }
        </div>

        @if (showDailyChallenge()) {
          <div class="e-progress">
            <div class="c-dailyChallenge__progressBar">
              <div class="e-progress-bar">
                <div
                  class="e-pre-progres-bar"
                  theming
                  themingGroup="dailychallenge"
                  themingAsset="progressive-points-box"
                  data-testid="slotcom-daily-challenge-progress-box"
                  [themingOverride]="dailyChallenge?.assets">
                  <div class="points">
                    <span class="text">{{ dailyChallenge.current }}/{{ dailyChallenge.total }}</span>
                  </div>

                  <div
                    class="points-icon"
                    theming
                    themingGroup="dailychallenge"
                    themingAsset="points-icon"
                    [themingOverride]="dailyChallenge?.assets"></div>
                </div>

                <slotcom-event-progress-bar
                  [classes]="['dailyChallenge']"
                  [currentProgress]="dailyChallenge.current"
                  [totalProgress]="dailyChallenge.total"
                  [eventProgressBarData]="eventProgressBarData"
                  [animated]="true">
                  <ng-template
                    #eventProgressBarIntervalContent
                    let-item="item">
                    <div
                      class="rewards-card"
                      [ngClass]="{
                        'reward-card--completed': dailyChallenge.current >= item.points && !item.redeemed
                      }"
                      [@unlockAnimation]="dailyChallenge.current >= item.points ? 'unlocked' : 'locked'"
                      avoidMulticlick
                      (safeClick)="collectProgressiveReward(item.points)">
                      <div
                        class="reward-card-background"
                        [ngClass]="{
                          'reward-card--completed': dailyChallenge.current >= item.points,
                          'reward-card--redeemed': item.redeemed
                        }"
                        [@redeemAnimation]="item.redeemed ? 'redeemed' : 'unlocked'"
                        theming
                        themingGroup="dailychallenge"
                        [themingAsset]="
                          dailyChallenge.current >= item.points ? 'progressive-active-box' : 'progressive-inactive-box'
                        "
                        [themingOverride]="dailyChallenge?.assets">
                        <span [ngClass]="'reward-currency ' + 'reward-currency--' + item.currency"></span>
                        <span class="text reward">{{
                          item.reward | beautifyNumber: ('common.culture' | translate)
                        }}</span>
                      </div>
                      @if (item.redeemed) {
                        <span
                          class="check-icon"
                          [@redeemAnimation]="'redeemed'"></span>
                      }

                      @if (dailyChallenge.current < item.points) {
                        <span class="locker-icon"></span>
                      }
                    </div>
                  </ng-template>
                </slotcom-event-progress-bar>
              </div>
            </div>
          </div>
          <slotcom-streak
            [showInfoButton]="true"
            [event]="dailyChallenge"></slotcom-streak>
        }
      </div>

      <div
        invertMouseScroll
        id="dailyChallenge-scroll-container"
        class="c-dailyChallenge__container__bottom"
        theming
        themingGroup="dailychallenge"
        themingAsset="bottom-background"
        [themingOverride]="dailyChallenge?.assets"
        (scroll)="manageSliderArrowVisibility()">
        @if (!showDailyChallenge() || newChallengesComing()) {
          <div class="c-dailyChallenge__container__image c-dailyChallenge__container__image-inactive"></div>
          <div class="c-dailyChallenge__info">
            <span class="text title">
              {{ 'home.modals.daily-challenge.title-inactive' | translate }}
            </span>
            <span class="text subtitle">
              {{ 'home.modals.daily-challenge.subtitle-inactive' | translate }}
            </span>
          </div>
        } @else if (
          dailyChallenge.current === dailyChallenge.total ||
          redeemedChallenges() === dailyChallenge.properties.challengestatuses.length
        ) {
          <div class="text-timer">
            <span class="text">{{ 'home.modals.daily-challenge.challenges-update-timer' | translate }}:</span>

            <slotcom-animated-timer
              [showInDays]="true"
              [endDate]="dailyChallenge.properties.challengestatuses[0].endDate"
              (expired)="challengesEnded()"></slotcom-animated-timer>
          </div>
          <div
            id="dailyChallenge__container__confetti"
            class="c-dailyChallenge__container__image"></div>
          <div class="c-dailyChallenge__container__image c-dailyChallenge__container__image-completed"></div>
          <div class="c-dailyChallenge__info">
            <div class="c-dailyChallenge__text">
              <span class="text title big-title">
                {{ 'common.congratulations' | translate | uppercase }}
              </span>
              <span class="text subtitle">
                {{ 'home.modals.daily-challenge.subtitle-completed' | translate }}
                <br />
                {{ 'home.modals.daily-challenge.subtitle-completed-2' | translate }}</span
              >
            </div>
          </div>
        } @else {
          <div class="e-challenges">
            <div class="e-challenges__header">
              <span class="text-challenges text"
                >{{ 'home.modals.daily-challenge.challenges-completed' | translate }} {{ completedChallenges() }}/{{
                  dailyChallenge.properties.challengestatuses.length
                }}</span
              >

              <div class="text-timer">
                <span class="text">{{ 'home.modals.daily-challenge.challenges-update-timer' | translate }}:</span>

                <slotcom-animated-timer
                  [showInDays]="true"
                  [endDate]="dailyChallenge.properties.challengestatuses[0].endDate"
                  (expired)="challengesEnded()"></slotcom-animated-timer>
              </div>
            </div>
            <div class="c-slider-challenges">
              @for (challenge of dailyChallenge.properties.challengestatuses; track challenge; let i = $index) {
                @if (!challenge.redeemed && !challenge.locked) {
                  <slotcom-challenge-card
                    [attr.data-testid]="'slotcom-dailyChallenge-unlocked-challenge-' + i"
                    [challenge]="challenge"
                    (prestigeRedeemed)="onPrestigeRedeemed($event)">
                  </slotcom-challenge-card>
                }

                @if (challenge.locked) {
                  <slotcom-challenge-card
                    [attr.data-testid]="'slotcom-dailyChallenge-locked-challenge-' + i"
                    [challenge]="challenge"
                    [blockedChallenges]="blockedChallengesList[i]"
                    (prestigeRedeemed)="onPrestigeRedeemed($event)">
                  </slotcom-challenge-card>
                }
              }
            </div>
          </div>

          @if (showScrollBack()) {
            <span class="c-scrollbar__button arrow-background left"> </span>

            <slotcom-navigation-button
              type="arrow-left"
              [topPosition]="28"
              [leftPosition]="1"
              moveWithArrows
              direction="left"
              scrollContainer="dailyChallenge-scroll-container"
              [scrollDistance]="500">
            </slotcom-navigation-button>
          }

          @if (showScrollNext()) {
            <span class="c-scrollbar__button arrow-background right"> </span>

            <slotcom-navigation-button
              type="arrow-right"
              [topPosition]="28"
              [rightPosition]="1"
              moveWithArrows
              direction="right"
              scrollContainer="dailyChallenge-scroll-container"
              [scrollDistance]="500">
            </slotcom-navigation-button>
          }
        }
      </div>
    </div>
  </div>
</div>
